import React, { useState, useEffect, useRef } from 'react'
import { useTranslation } from 'react-i18next';
import menuArrow from '../../../icons/menu_arrow.svg'
import { ExpandedNav, Portfolio, List, ListItem, Title, PortfoliosButton, ExpandSectionIcon } from './section.styled';

const useOutsideAlerter = (ref, buttonRef, func) => {
  useEffect(() => {
    function handleClickOutside(event) {
      if (ref.current && !ref.current.contains(event.target) && !buttonRef.current.contains(event.target)) {
        func();
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [ref, func]);
}

export const PortfoliosSection = () => {
  const { t } = useTranslation();
  const expandedNavRef = useRef(null);
  const navButton = useRef(null);

  const portfolioCategories = t(`PortfolioCategories`, { returnObjects: true });
  const [openSection, setOpenSection] = useState(false);
  const toggleSection = () => {
    setOpenSection(!openSection)
  }
  const handleScrollTop = () => window.scrollTo(0, 0);
  
  useOutsideAlerter(expandedNavRef, navButton, toggleSection)
  const handleClick = e =>{
    e.preventDefault();
    setOpenSection(!openSection);
    handleScrollTop();
  }
  return (
    <>
      <PortfoliosButton isOpen={openSection} ref={navButton} onClick={toggleSection}>
        <span>{t('CategoriesData.title')}&nbsp;</span>
        <ExpandSectionIcon isOpen={openSection} src={menuArrow} alt="Expand" height='16px' width='16px' />
      </PortfoliosButton>
      {openSection && (
        // <OutsideAlerter>
          <ExpandedNav ref={expandedNavRef}>
            {portfolioCategories.map((item) => {
              return (
                <Portfolio key={item.name}>
                  <Title to={`/portfolios/${item.name}`} onClick={() => handleClick()}>{item.displayName} ({item.portfolios.length})</Title>
                  <List>
                    <ListItem>{item.terms.title}:</ListItem>
                    <ListItem>{item.includeItems[0]}</ListItem>
                    <ListItem>{item.includeItems[1]}</ListItem>
                  </List>
                </Portfolio>
              )
            })}
          </ExpandedNav>
        // </OutsideAle rter>
      )}
    </>
  )
}